import { useState, useEffect } from 'react';
import { usePlatforms } from '../hooks/usePlatforms';
import { translate } from '../utils/Common';
import { cn } from '@/lib/utils';
import { FIELD_SKIN } from '@/components/ui/form-field';
import ignoreAbort from '../utils/ignoreAbort';

const DoorList = ({
    register,
    nameShow,
    idShow,
    readOnly,
    className
}) => {
    const { getDoors } = usePlatforms();
    const [doorsList,setDoorsList] = useState(null);
    useEffect(() => {
        const abortController = new AbortController();
        const handleDoors = async () => {
            const doors = await getDoors(idShow, abortController.signal);
            setDoorsList(doors);
        }
        handleDoors().catch(ignoreAbort);
        return () => abortController.abort();
    }, [idShow, getDoors]);

    return  (
        <select className={cn(FIELD_SKIN, 'flex w-full px-3 transition-[border-color,box-shadow]', className)}
            name="puerta"
            readOnly={readOnly}
            ref={ register()} >
            <option defaultValue value={0} key={0}>{nameShow ? nameShow : translate("global.noDoor")}</option>
            { doorsList ?
                doorsList?.map(door => 
                    (idShow !== door.IdPlataformaDet) && 
                    <option key={door.IdPlataformaDet} value={ door.IdPlataformaDet }>{`${door.Identificacion} - ${door.Dimension}`}</option>)
                :
                <option defaultValue key={1}>{translate("global.alert.noDoorsAvailable")}</option>
            }
        </select>
    )
}

export default DoorList;